import {
    FETCH_BOOKING_LOCATION,
    FETCH_BOOKING_LOCATION_SUCCESS,
    FETCH_BOOKING_LOCATION_FAILED,
    STOP_LOCATION_FETCH,
    STORE_ADRESSES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { query, onValue, set, off, push, get, limitToLast, serverTimestamp } from "firebase/database";

export const saveTracking = (bookingId, location) => {
    const {
        trackingRef
    } = firebase;
    push(trackingRef(bookingId), location);
}

export const fetchBookingLocations = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: bookingId,
    });
    onValue(query(trackingRef(bookingId), limitToLast(1)),(snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const locations = Object.keys(data)
                .map((i) => {
                    return data[i]
                });
            if (locations.length == 1) {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_SUCCESS,
                    payload: locations[0]
                });
            }
            else {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
                });
            }
        } else {
            dispatch({
                type: FETCH_BOOKING_LOCATION_FAILED,
                payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
            });
        }
    });
};

export const stopLocationFetch = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: STOP_LOCATION_FETCH,
        payload: bookingId,
    });
    off(trackingRef(bookingId));
}

export const saveUserLocation = (location) => {
    const {
      auth,
      userLocationRef,
    } = firebase;
    if (!auth.currentUser) {
        return;
    }
    const uid = auth.currentUser.uid;
    // `at` (server clock) lets dispatch skip drivers whose app stopped reporting; see driverLocationIsFresh.
    set(userLocationRef(uid), Object.assign({}, location, { at: serverTimestamp() }));
}

// Server clock minus this client's clock, in ms (0 when unknown or offline). Dispatch judges `at`
// stamps (server time) against it, so a wrong PC or phone clock can neither make every driver look
// stale nor keep a killed app looking alive.
export const fetchServerTimeOffset = () => new Promise((resolve) => {
    const {
      serverTimeOffsetRef,
    } = firebase;
    const timer = setTimeout(() => resolve(0), 3000);
    const done = (offset) => { clearTimeout(timer); resolve(offset); };
    onValue(serverTimeOffsetRef, (snapshot) => done(Number(snapshot.val()) || 0), () => done(0), { onlyOnce: true });
});

// One fresh read of every driver's last reported position (locations/<uid> -> { lat, lng, at }) and the
// server time to judge them by, taken at the moment a booking is dispatched (see selectDispatchDrivers).
export const fetchDriverLocations = async () => {
    const {
      allLocationsRef,
    } = firebase;
    const results = await Promise.all([get(allLocationsRef), fetchServerTimeOffset()]);
    return { locations: results[0].val() || {}, now: Date.now() + results[1] };
}

export const storeAddresses = (data) => (dispatch) => {
    dispatch({
        type: STORE_ADRESSES,
        payload: data,
    });
}